import {h, Fragment} from "preact"
import { usePagination, useActions } from "@nosto/preact"

function PageLink({ onClick, href, className, ariaLabel, children }) {
    return (
        <a
            class={`ns-page-link ${className}`}
            href={href}
            aria-label={ariaLabel}
            onClick={onClick}
        >
            {children}
        </a>
    )
}

export default function Pagination() {
    const { prev, first, pages, last, next } = usePagination({ width: 3 })
    const { updateSearch, simulateUpdateSearch } = useActions()

    function pageLinkProps({ from }) {
        return {
            onClick: e => {
                e.preventDefault()
                updateSearch({ products: { from } })
                scrollTo(0, 0)
            },
            href: simulateUpdateSearch({ products: { from } }).url
        }
    }

    return (
        <nav role="navigation" class="py-lg lg:group-aria-expanded/drawer:ml-[-339px] relative lg:z-[1]">
            <ol class="flex flex-wrap justify-center m-0 p-0">
                {prev && (
                    <div class="flex justify-center items-center mr-5 lg:mr-7">
                        <PageLink 
                            className="ns-previous block leading-none" 
                            ariaLabel="Previous page"
                            {...pageLinkProps(prev)} 
                        >
                            <svg fill="none" class="rotate-180 icon icon-arrow" id="icon-arrow" viewBox="0 0 32 33" role="presentation" focusable="false">
                                <path stroke="currentColor" d="m20.89 26.038 9.777-9.778m0 0-9.778-9.778m9.778 9.778H1.334"></path>
                            </svg>
                        </PageLink>
                    </div>
                )}

                {first && (
                    <>
                        <li>
                            <PageLink 
                                className="border border-t-border flex items-center justify-center body-14 px-1 h-10 w-10"
                                ariaLabel="First page" 
                                {...pageLinkProps(first)} 
                            >
                                {first.page}
                            </PageLink>
                        </li>
                        <li class="h-10 w-5 flex items-center justify-center mr-1.5 lg:mr-2.5">
                            <span class="-mt-3">...</span>
                        </li>
                    </>
                )}

                {pages.map(page => (
                    <li 
                        key={page.page} 
                        class={
                            `${page.current 
                                ? "ns-active border border-t-foreground-secondary last-of-type:mr-0 flex justify-center items-center body-14 px-1 mr-1.5 lg:mr-2.5 h-10 w-10" 
                                : "mr-1.5 lg:mr-2.5 last-of-type:mr-0"
                            }`
                        }
                    >
                        {page.current ? (
                            <>{page.page}</>
                        ) : (
                            <PageLink 
                                className="border border-t-border flex items-center justify-center body-14 px-1 h-10 w-10" 
                                ariaLabel={`${page.page} page`} 
                                {...pageLinkProps(page)}
                            >
                                {page.page}
                            </PageLink>
                        )}
                    </li>
                ))}

                {last && (
                    <>
                        <li class="h-10 w-5 flex items-center justify-center mr-1.5 lg:mr-2.5">
                            <span class="-mt-3">...</span>
                        </li>
                        <li class="mr-1.5 lg:mr-2.5 last-of-type:mr-0">
                            <PageLink 
                                className="border border-t-border flex items-center justify-center body-14 px-1 h-10 w-10" 
                                ariaLabel="Last page"
                                {...pageLinkProps(last)} 
                            >
                                {last.page}
                            </PageLink>
                        </li>
                    </>
                )}

                {next && (
                    <div class="flex justify-center items-center ml-5 lg:ml-7">
                        <PageLink 
                            className="ns-next block leading-none" 
                            ariaLabel="Next page"
                            {...pageLinkProps(next)} 
                        >
                            <svg fill="none" class="icon icon-arrow" id="icon-arrow" viewBox="0 0 32 33"  role="presentation" focusable="false">
                                <path stroke="currentColor" d="m20.89 26.038 9.777-9.778m0 0-9.778-9.778m9.778 9.778H1.334"></path>
                            </svg>
                        </PageLink>
                    </div>
                )}
            </ol>
        </nav>
    )
}